import { useNavigate } from "react-router-dom";

import "./HelpCenter.css";
import botLogo from "../../Assets/logo-update.png";
import integrationLogo from "../../Assets/requestIntegration.png";
import goLiveLogo from "../../Assets/goLiveIntegrate.png";
import accountSettingsLogo from "../../Assets/accountSettings.png";

export default function HelpCenter() {
  const navigate = useNavigate();

  return (
    <div className="help-wrapper">

      <div className="help-navbar">
        <img src={botLogo} alt="Logo" className="help-logo" />

        <button
          className="support-btn"
          onClick={() => window.location.href = "mailto:support@xenachat.com?subject=Support%20Request"}
        >
          Contact Support
        </button>
      </div>

      <div className="help-header">
        <h1>HOW CAN WE HELP YOU?</h1>
      </div>

      <div className="search-container">
        <input
          type="text"
          placeholder="Search for articles..."
          className="search-input"
        />
      </div>

      <div className="help-cards">

        <div className="help-card">
          <div className="card-icon">
            <img src={ goLiveLogo } alt="goLive" className="card-icon-img" />
          </div>
          <h3>Getting Started</h3>
          <p>Setup guides and documentation</p>

          <button
            className="learn-btn"
            onClick={() => navigate("/docs")}
          >
            Learn More
          </button>
        </div>

        <div className="help-card">
          <div className="card-icon"> <img src={integrationLogo} alt="Integration Logo" /></div>
          <h3>Integrations</h3>
          <p>Connect with messaging platforms</p>

          <div className="integration-options">
            <button
              className="integration-btn"
              onClick={() => navigate("/integrations/whatsapp")}
            >
              💬 WhatsApp
            </button>

            <button
              className="integration-btn"
              onClick={() => navigate("/integrations/telegram")}
            >
              ✈️ Telegram
            </button>
          </div>
        </div>

        <div className="help-card">
          <div className="card-icon">
            <img src={accountSettingsLogo} alt="Account logo"></img>
          </div>
          <h3>Account & Settings</h3>
          <p>Manage profile and billing</p>
        </div>

      </div>

    </div>
  );
}
